import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import ControlButtons from '../ControlButtons'
import { StyledEditableElement, StyledListInput } from '../Styles'
import { createSubArea, editSubArea, deleteSubArea } from 'r_actions/properties.actions'


const ListInput = ({ element, edit, setEdit, area, placeholder, viewOnly }) => {

  const dispatch = useDispatch()

  const { id, title } = element
 
  const [name, setName] = useState(title)

  const onSubmitSub = () => {
    if(id==='new') {
      dispatch(createSubArea({ area, title: name }))
      return setName('')
    }
    dispatch(editSubArea({ id, data: { area, title: name } }))
  }

  const onDeleteSub = () => {
    if(id==='new') return 
    dispatch(deleteSubArea( id ))
  }
 
  useEffect(() => () => setEdit(null), [setEdit])
 

  return <StyledEditableElement className="panel-block" onClick={() => setEdit(id)}>

    <StyledListInput 
      className="input" 
      placeholder={placeholder}
      type="text" 
      value={name} 
      onChange={e => setName(e.target.value)}
      style={{ pointerEvents: viewOnly ? 'none' : 'all' }}
    />
 
    {
      (edit && !viewOnly) && 
      <>
        <ControlButtons disabled={!name || title===name} onSubmit={onSubmitSub} onDelete={onDeleteSub} />
      </>
    }
  
  </StyledEditableElement>
        
}

ListInput.propTypes = {
  subAreast: PropTypes.array,
  edit: PropTypes.bool,
  setEdit: PropTypes.func,
  area: PropTypes.number,
  placeholder: PropTypes.string,
  viewOnly: PropTypes.bool,
}

export default ListInput

